export default "__VITE_ASSET__CcV1XHFR__"